/* eslint-disable */

import React, {useState} from 'react';
import Modal from 'react-modal';
import AlertBlue from '../../_assets/svg/alert-blue.svg';
const customStyles = {
  content: {
    position: 'unset',
    inset: 'unset',
    border: 'unset',
    background: 'unset',
    overflow: 'unset',
    borderRadius: 'unset',
    outline: 'unset',
    padding: 'unset',
    marginRight: 'unset',
    transform: 'unset'
  },
};
function BadgeInfo() {
  const [isOpenModal, setOpenModal]=useState(false);
  return (
    <div>
    <Modal
      isOpen={isOpenModal}
      onRequestClose={()=>setOpenModal(true)}
      style={customStyles}
      contentLabel="Example Modal"
    >
    <div className="modal-badge-template card p-3">
      <div className='d-flex align-items-center justify-content-between px-2'>
        <h3>Terms Of Use</h3>
        <div className="close-action" onClick={()=>setOpenModal(false)}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18" stroke="#7A869A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M6 6L18 18" stroke="#7A869A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </div>
        <div className="row card-body p-4">
        <ul className="content-terms pl-4">
          <li>Header bisa dipilih salah satu antara text, media, no header.</li>
          <li>
            Untuk header tidak bisa menggunakan dua [ ] dalam satu template contoh :
            <b>[NO REPLY] [CONFIRMATION]</b>.
          </li>
          <li>
            Website link ataupun URL harus menggunakan variable <b>[link]</b> untuk
            menghindari status rejected contoh : bit.ly.
          </li>
          <li>
            Template yang menggunakan media ada ketentuan seperti berikut :<br />
            Gambar : .jpeg /.png dengan max size 5 MB<br />
            Video : max size 16 MB<br />
            PDF : max size 100 MB
          </li>
          <li>Menghindari konten template yang berisikan promosi atau iklan.</li>
          <li>
            Menghindari jumlah variable lebih banyak dibandingkan isi wordingan pada template.
          </li>
          <li>
            Template memiliki karakter maksimal sebanyak 1024 include isi variable.
          </li>
          <li>Template yang memakai button karakter maksimal 20.</li>
          <li>Template yang memakai name payload URL maksimal karakter 20.</li>
          <li>Template name tidak dapat menggunakan spesial karakter dan spasi.</li>
          <li>Variable yang sudah digunakan, tidak dapat digunakan di awal dan juga di akhir paragraf template.</li>
          <li>Gunakan kata penghubung tambahan, jika ingin menggunakan dua Variable, atau Variable yang digunakan saling bertemu dalam satu kalimat.</li>
          <li>Jumlah karakter dari setiap Variable, tidak boleh melebihi jumlah paragraf template yang akan digunakan. Sedangkan untuk setiap Variable yang akan digunakan, memiliki sifat yang dinamis.</li>
        </ul>
        <div className='ex_info'>
          Contoh: Template yang akan digunakan, “Hai [name],” secara kalkulasi Hai = 3 kata, dan Variable = 4. Jadi jumlah karakter Variable melebihi jumlah penggunaannya.
        </div>
        </div>
    </div>
    </Modal>
      <div className='oca-badge-info'>
        <div className='d-flex align-items-center badge-terms'>
            <img src={AlertBlue} className='me-2'></img>
            <p className='mb-0'>Terms of Use</p>
        </div>
        <button onClick={()=>setOpenModal(true)} className="btn cl-blue-primary">
            Read
        </button>
      </div>
    </div>
  )
}

export default BadgeInfo